<template>
  <div>
    <div class="flex header">
      <div class="lbl-header">{{ headerTitle }}</div>
      <div>
        <div class="flex combo-options">
          <div class="flex">
            <BaseOverCircle>
              <span
                v-tooltip="{
                  content: !showFilters
                    ? $t('mefo.showFilterOptions')
                    : $t('mefo.hideFilterOptions'),
                  placement: 'right',
                }"
                class="btn-header"
                @click="$emit('toggleFilters')"
                style="
                  width: 19px;
                  height: 19px;
                  display: flex;
                  justify-content: center;
                "
              >
                <div
                  style="
                    width: 18px;
                    height: 18px;
                    display: flex;
                    align-items: center;
                  "
                >
                  <div
                    style="
                      width: 16px;
                      height: 16px;
                      fill: #fff;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <Icons
                      :icon="!showFilters ? 'plus' : 'minimize'"
                      height="12px"
                      width="12px"
                    />
                  </div>
                </div>
              </span>
            </BaseOverCircle>
            <BaseOverCircle v-if="otzarVersion > 22">
              <span
                class="btn-header btn-header-white btn-search"
                style="stroke: #fff"
                @click="$emit('toggleSearch')"
                v-tooltip="$t('freeSearchInput.searchInMeforshim')"
              >
                <div class="close-btn">
                  <Icons icon="magnifier" height="14px" width="14px" />
                </div>
              </span>
            </BaseOverCircle>
            <BaseOverCircle>
              <span
                class="btn-header btn-header-white btn-header-close"
                style="fill: #fff; stroke: none"
                @click="$emit('closeMef')"
              >
                <div class="close-btn">
                  <Icons icon="exit" height="10px" width="10px" />
                </div>
              </span>
            </BaseOverCircle>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icons from "@/components/Icons/Icons.vue";
import { shasVilnaBooks } from "@/services/bookData";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      color: "#626262",
    };
  },
  components: { Icons },
  props: ["minimizeAll", "gridMode", "bookview", "showFilters"],
  computed: {
    ...mapGetters("tabsManager", ["getCurrentBook", "getCurrentTabId"]),
    rambamTitle() {
      return (
        this.$store.state.tabs[this.getCurrentTabId].rambamSecSelectedTitle ||
        ""
      );
    },
    headerTitle() {
      return shasVilnaBooks.includes(this.getCurrentBook)
        ? "מפרשי הדף"
        : `מפרשי הרמב"ם ${this.rambamTitle}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  min-height: 39px;
  color: rgb(152, 119, 79);
  background-color: var(--custom-color1) !important;
  align-items: center;
  padding: 0px 11px;
  padding-left: 3px;
  justify-content: space-between;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: #dedede;
}
.cmb {
  width: 107px;
  border-color: var(--custom-color1);
}
.combo-options {
  align-items: center;
}
.close-btn {
  width: 18px;
  height: 18px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lbl-order-by {
  padding: 0px 5px;
  display: inline-block;
  font-size: 12px;
  color: var(--text-color1);
  font-weight: 400;
}
.btn-header-white.btn-header {
  &:hover {
    fill: #fff !important;
    stroke: none !important;
  }
}
.btn-header-white.btn-search {
  &:hover {
    stroke: #fff !important;
  }
}
.btn-header.btn-header-close {
  display: flex;
  margin: 0px 0px;
  border-radius: 50%;
  padding: 2px;
  background-color: #00000014;
}
.lbl-header {
  color: white; // var(--text-color1);
  flex-grow: 1;
  text-align: right;
  font-size: 16px;
}
</style>
